(() => {
  const readVariants = () => {
    const node = document.querySelector('[data-cv-lorex-cndl-x3-controller] [data-cv-lorex-cndl-x3-variants]');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent || '[]');
    } catch (_) {
      return [];
    }
  };

  const initFaq = (root = document) => {
    root.querySelectorAll('[data-cv-lorex-cndl-x3-faq]:not([data-cv-lorex-cndl-x3-ready])').forEach((list) => {
      list.dataset.cvLorexCndlX3Ready = 'true';

      const syncExpandedState = (details) => {
        const summary = details.querySelector(':scope > summary');
        if (summary) summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      };

      list.querySelectorAll('details').forEach(syncExpandedState);

      list.addEventListener('keydown', (event) => {
        const summary = event.target.closest('summary');
        if (!summary || !list.contains(summary) || !['Enter', ' ', 'Spacebar'].includes(event.key)) return;

        const details = summary.parentElement;
        if (!(details instanceof HTMLDetailsElement)) return;

        event.preventDefault();
        details.open = !details.open;
        syncExpandedState(details);
      });

      list.addEventListener('toggle', (event) => {
        const opened = event.target;
        if (!(opened instanceof HTMLDetailsElement)) return;

        syncExpandedState(opened);
        if (!opened.open || list.dataset.multiple === 'true') return;

        list.querySelectorAll('details[open]').forEach((item) => {
          if (item !== opened) item.open = false;
        });
      }, true);
    });
  };

  const initFinalCta = (root = document) => {
    root.querySelectorAll('[data-cv-lorex-cndl-x3-final-cta]:not([data-cv-lorex-cndl-x3-ready])').forEach((cta) => {
      cta.dataset.cvLorexCndlX3Ready = 'true';
      const finalButton = cta.querySelector('[data-cv-lorex-cndl-x3-final-add]');
      const finalPrice = cta.querySelector('[data-cv-lorex-cndl-x3-final-price]');
      const finalModel = cta.querySelector('[data-cv-lorex-cndl-x3-final-model]');
      const status = cta.querySelector('[data-cv-lorex-cndl-x3-final-status]');
      const purchase = document.querySelector('[data-cv-lorex-cndl-x3-controller]');
      const variantInput = purchase?.querySelector('[data-cv-lorex-cndl-x3-variant-input]');
      const variants = readVariants();

      if (!finalButton || !purchase || !variantInput) return;

      let activeVariant = variants.find((variant) => String(variant.id) === String(variantInput.value)) || variants[0];
      const currentVariant = () => activeVariant;
      const syncVariant = (variant = currentVariant()) => {
        activeVariant = variant || variants[0];
        variant = activeVariant;
        if (finalPrice && variant?.priceFormatted) finalPrice.textContent = variant.priceFormatted;
        if (finalModel && variant?.sku) finalModel.textContent = `${cta.dataset.modelLabel} ${variant.sku}`;
        const unavailable = !variant?.available;
        finalButton.disabled = unavailable;
        finalButton.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
      };
      const syncPurchaseState = () => {
        const mainButton = purchase.querySelector('[data-cv-lorex-cndl-x3-add]');
        if (!mainButton) return;
        const busy = mainButton.getAttribute('aria-busy') === 'true' || mainButton.hasAttribute('data-added');
        const unavailable = !currentVariant()?.available;
        finalButton.disabled = busy || unavailable;
        finalButton.setAttribute('aria-disabled', busy || unavailable ? 'true' : 'false');
        finalButton.setAttribute('aria-busy', busy ? 'true' : 'false');
        if (busy && status) status.textContent = 'Adding through the secure product form…';
      };

      window.addEventListener('cv-lorex-cndl-x3:variant-change', (event) => {
        if (String(event.detail?.productId) !== String(cta.dataset.productId)) return;
        syncVariant(event.detail.variant);
        syncPurchaseState();
      });

      finalButton.addEventListener('click', () => {
        if (status) status.textContent = 'Adding through the secure product form…';
      });

      const purchaseObserver = new MutationObserver(() => {
        syncPurchaseState();
        const error = purchase.querySelector('[ref="addToCartTextError"]')?.textContent?.trim();
        if (error && status) status.textContent = error;
      });
      purchaseObserver.observe(purchase, {
        attributes: true,
        attributeFilter: ['aria-busy', 'data-added', 'disabled'],
        childList: true,
        characterData: true,
        subtree: true,
      });

      syncVariant();
      syncPurchaseState();
    });
  };

  const init = (root = document) => {
    initFaq(root);
    initFinalCta(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
